import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-primary-rectangle-button',
  templateUrl: './primary-rectangle-button.component.html',
  styleUrls: ['./primary-rectangle-button.component.less'],
})
export class PrimaryRectangleButtonComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() width = '';
  @Input() height = '';
  
  @Output() onClick = new EventEmitter<any>();

  onClickButton(event) {
    this.onClick.emit(event);
  }

  constructor() {}

  ngOnInit(): void {}
}
